import {

    FaCar,

    FaTools,

    FaMoneyBillWave,

    FaPlus,

} from "react-icons/fa";

import styles from "./GettingStartedCard.module.css";

const GettingStartedCard = ({

    carCount = 0,

    serviceCount = 0,

    expenseCount = 0,

}) => {

    return (

        <section className={styles.card}>

            <h3>

                شروع استفاده از اتویاد

            </h3>

            <p>

                برای شروع، مراحل زیر را انجام دهید.

            </p>

            <div className={styles.steps}>

                <div

                    className={`${styles.step}

                    ${carCount > 0

                        ? styles.done

                        : ""}`}

                >

                    <FaCar />

                    <span>

                        ثبت اولین خودرو

                    </span>

                </div>

                <div

                    className={`${styles.step}

                    ${serviceCount > 0

                        ? styles.done

                        : ""}`}

                >

                    <FaTools />

                    <span>

                        ثبت اولین سرویس

                    </span>

                </div>

                <div

                    className={`${styles.step}

                    ${expenseCount > 0

                        ? styles.done

                        : ""}`}

                >

                    <FaMoneyBillWave />

                    <span>

                        ثبت اولین هزینه

                    </span>

                </div>

            </div>

            <div className={styles.tip}>

                <FaPlus />

                <span>

                    برای ثبت اطلاعات جدید

                    از دکمه

                    <strong>

                        {" "}+{" "}

                    </strong>

                    پایین صفحه استفاده کنید.

                </span>

            </div>

        </section>

    );

};

export default GettingStartedCard;